import ListItemText from './ListItemText';

export default ListItemText;
